import { IProduct } from '../../../../../../graphql/order/models/get-orders.models';

export const getOrderPackages = (products: IProduct[]): number => {
  return products.reduce((acc, item) => acc + item.productQuantity, 0);
};
